
<div class="tw:flex tw:h-full">
    <div class="chart-wrapper">
        <canvas baseChart
            [datasets]="lineChartData"
            [labels]="lineChartLabels"
            [options]="lineChartOptions"
            [legend]="lineChartLegend"
            [type]="lineChartType"
            [plugins]="lineChartPlugins">
        </canvas>
    </div>
</div>